import { isLoggedInVar } from "../../config/apollo-cache";
import apolloClient from "../../config/apollo";

export const logout = () => {
  // window.heap.resetIdentity();
  localStorage.removeItem("token");
  apolloClient.clearStore();
  isLoggedInVar(false);
};
